module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-16-8d6fe16f26a52f50e25e8f7ccc4db2a1.jpg";